import {KTCard} from '../../../../_metronic/helpers'
import {SubCategoriesTable} from './SubCategoriesTable'

const ClassifiedSubCategoriesList = () => {
  return (
    <>
      <KTCard>
        <SubCategoriesTable />
      </KTCard>
    </>
  )
}

const ClassifiedSubCategoriesListWrapper = () => <ClassifiedSubCategoriesList />

export {ClassifiedSubCategoriesListWrapper}
